import React, { useCallback, useState } from 'react';
import { PhoneForwarded } from '@mui/icons-material';
import { Box, Typography, styled } from '@mui/material';
import { usePhoneActions } from '../../hooks/use-phone';
import { RoundButton } from '../round-button';
import Numpad from '../numpad';


const Container = styled(Box)({
    marginTop: 20,
    textAlign: 'center'
});

const Title = styled(Typography)(styles => ({
    color: styles.theme.palette.info.main
}));

const Button = styled(RoundButton)({
    marginTop: 16,
    marginBottom: 24
});

export default function Transfer(props: { callId: string; interceptKeyboard?: boolean }) {
    const [text, setText] = useState('');
    const { playTones, transfer } = usePhoneActions();

    const handleOnChar = useCallback(
        (ch: string) => {
            playTones(ch);
        },
        [playTones]
    );

    return (
        <Container data-testid='transfer-div'>
            <Title variant='subtitle2'>TRANSFER CALL</Title>
            <Numpad
                onChar={handleOnChar}
                onTextChange={setText}
                interceptKeyboard={props.interceptKeyboard}
                numberField='text'
                formatPhoneNumber={true}
            />
            <Button
                toggled
                variant='lg'
                data-testid='transfer-button'
                onClick={() => transfer({ id: props.callId, number: text })}
            >
                <PhoneForwarded />
            </Button>
        </Container>
    );
}
